import React, { useState } from "react";
import { CONNECTOR_LABEL, SIGNAL_LEVEL_LABEL } from "../constants/signalLabels";

function PortDetailInner({ node, port, exclusionNote, isExcluded, onUpdateExclusion }) {
  const device = node?.data?.device;
  const [note, setNote] = useState(exclusionNote || "");

  const connectorLabel = CONNECTOR_LABEL[port.connector] || port.connector;
  const levelLabel = SIGNAL_LEVEL_LABEL[port.signal_level] || port.signal_level;
  const details = [connectorLabel, levelLabel].filter(Boolean).join(" \u00b7 ");

  function handleToggle(e) {
    if (e.target.checked) {
      onUpdateExclusion(node.id, port.id, note || null);
    } else {
      onUpdateExclusion(node.id, port.id);
      setNote("");
    }
  }

  function handleNoteBlur() {
    if (isExcluded) {
      onUpdateExclusion(node.id, port.id, note);
    }
  }

  function handleNoteKeyDown(e) {
    if (e.key === "Enter") {
      e.target.blur();
    }
  }

  return (
    <div className="port-detail-panel">
      <div className="port-detail-header">
        <div className="port-detail-name">{port.name}</div>
        <div className="port-detail-info">{details}</div>
        {device && (
          <div className="port-detail-device">{device.display_name || device.name}</div>
        )}
      </div>
      <label className="port-detail-exclude-toggle">
        <input
          type="checkbox"
          checked={isExcluded}
          onChange={handleToggle}
        />
        Exclude this port
      </label>
      {isExcluded && (
        <div className="port-detail-note-field">
          <label className="port-detail-note-label" htmlFor="exclusion-note">
            Reason
          </label>
          <input
            id="exclusion-note"
            type="text"
            className="port-detail-note-input"
            placeholder="e.g. Bleed from adjacent channel"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            onBlur={handleNoteBlur}
            onKeyDown={handleNoteKeyDown}
          />
        </div>
      )}
    </div>
  );
}

export default function PortDetailPanel({ node, portId, onUpdateExclusion }) {
  const device = node?.data?.device;
  const excludedPorts = node?.data?.excludedPorts || {};
  const port = (device?.device_ports || []).find((p) => String(p.id) === String(portId));

  if (!port) return null;

  const key = String(portId);
  const isExcluded = Object.prototype.hasOwnProperty.call(excludedPorts, key);
  const exclusionNote = isExcluded ? excludedPorts[key] : null;

  return (
    <PortDetailInner
      key={`${node.id}-${portId}-${isExcluded}`}
      node={node}
      port={port}
      exclusionNote={exclusionNote}
      isExcluded={isExcluded}
      onUpdateExclusion={onUpdateExclusion}
    />
  );
}
